// extracted by mini-css-extract-plugin
export default {"title":"Contact_title__rGHXv","formContent":"Contact_formContent__5-lfa","form":"Contact_form__JjY-O","input":"Contact_input__XK-NI","errors":"Contact_errors__e7TDR"};